<script>
import bem from '@/utils/bem';
import isUrl from '@/utils/isUrl';

const b = bem('help-center-preview');

export default {
  data() {
    return {
      previewFiles: [],
      selectedItemId: null,
    };
  },
  props: {
    hint: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isUrl,
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    handleOk() {
      this.hideModal();
    },
    getImgUrl(index) {
      return this.previewFiles[index].image;
    },
    selectImage(img, index) {
      this.selectedItemId = index;
    },
    getVideoUrl(index) {
      return this.previewFiles[index].image.replace('560', '100%');
    },
  },
  mounted() {
    this.previewFiles = this.hint.images;
    this.selectedItemId = 0;
  },
};
</script>

<template>
  <div  :class="b('wrapper')">
    <h1 class="text-2xl font-bold mb-2">Preview hint help center</h1>
    <h2 :class="b('title')">{{ hint.title }}</h2>
    <div :class="b('content')">
      <div :class="b('block-images')" v-if="previewFiles && previewFiles.length" >
        <div :class="b('main-image')">
          <div v-if="getImgUrl(selectedItemId)[0] === '<'">
            <div
              id="videoUrl"
              :class="b('video-file')"
              v-html="getVideoUrl(selectedItemId)"
            />
          </div>
          <div v-else>
            <img
              :class="b('image')"
              :src="getImgUrl(selectedItemId)"
              alt="aaa"
            >
          </div>
        </div>
        <div :class="b('images-list-wrap')">
          <div
            :class="b('images-list')"
          >
            <button
              :class="b('item-image', { selected: selectedItemId === index })"
              type="button"
              v-for="(img, index) in previewFiles"
              :key="img"
              @click.capture.stop="this.selectImage(img, index)"
            >
              <div v-if="img[0] === '<'">
                <div v-html="img.image.replace('560', '100%').replace('315', '100%')" />
              </div>
              <div v-else>
                <img
                  :class="b('image')"
                  :src="getImgUrl(index)"
                  alt="aaa"
                >
              </div>
            </button>
          </div>
        </div>
      </div>
      <div
        :class="b('description')"
        v-html="hint.description"
      />
    </div>
  </div>
</template>

<style src="./style.scss" scoped lang="scss"></style>
